import { Outlet } from "react-router-dom";
import Header from "./Header";

function PracticeLayout() {
  return (
    <>
      <Header />
      <Outlet />
    </>
  );
}

export default PracticeLayout;
